import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { useLang } from "@/context/LangContext";

export default function VendorsPanel() {
  const { t } = useLang();
  const [vendors, setVendors] = useState([]);
  const [status, setStatus] = useState("pending");

  const load = async (s) => {
    const { data } = await api.get("/admin/vendors", { params: { status: s, page_size: 100 } });
    setStatus(s);
    setVendors(data.items);
  };
  useEffect(() => { load("pending"); }, []);

  const approve = async (vid) => { await api.post(`/admin/vendors/${vid}/approve`); toast.success(t("ad.vendor_approved")); load(status); };
  const block = async (vid) => { await api.post(`/admin/vendors/${vid}/block`); toast.success(t("ad.vendor_hidden")); load(status); };

  return (
    <Card className="p-4 border-border/60">
      <div className="flex gap-2 mb-3">
        <Button size="sm" variant={status === "pending" ? "default" : "outline"} onClick={() => load("pending")} data-testid="admin-vendor-filter-pending">{t("ad.filter_pending")}</Button>
        <Button size="sm" variant={status === "approved" ? "default" : "outline"} onClick={() => load("approved")} data-testid="admin-vendor-filter-approved">{t("ad.filter_approved")}</Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t("ad.col_business")}</TableHead>
            <TableHead>{t("ad.col_owner")}</TableHead>
            <TableHead>{t("ad.col_category")}</TableHead>
            <TableHead>{t("ad.col_city")}</TableHead>
            <TableHead>{t("ad.col_status")}</TableHead>
            <TableHead>{t("ad.col_actions")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {vendors.map((v) => (
            <TableRow key={v.vendor_id}>
              <TableCell className="font-medium">{v.business_name}</TableCell>
              <TableCell>{v.owner_name}</TableCell>
              <TableCell>{v.category}</TableCell>
              <TableCell>{v.city}</TableCell>
              <TableCell>{v.is_approved ? <Badge>{t("ad.tag_approved")}</Badge> : <Badge variant="secondary">{t("ad.tag_pending")}</Badge>}</TableCell>
              <TableCell className="space-x-1">
                {!v.is_approved && <Button size="sm" onClick={() => approve(v.vendor_id)} data-testid={`approve-vendor-${v.vendor_id}`}>{t("ad.btn_approve")}</Button>}
                {v.is_approved && <Button size="sm" variant="destructive" onClick={() => block(v.vendor_id)} data-testid={`block-vendor-${v.vendor_id}`}>{t("ad.btn_hide")}</Button>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
